var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiamond = function SvgDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.976 8h24.048a1.69 1.69 0 0 1 1.365.695l6.45 8.868a.844.844 0 0 1-.063 1.068L24.62 39.383a.843.843 0 0 1-1.19.047c-.013-.01-6.412-6.942-19.205-20.8a.84.84 0 0 1-.063-1.068l6.45-8.868A1.69 1.69 0 0 1 11.976 8m.86 3.374L8.112 17.87 24 35.078 39.888 17.87l-4.724-6.496z"
  })));
};
export default SvgDiamond;